<template>
  <el-config-provider :locale="zhCn">
    <router-view />
  </el-config-provider>
</template>

<script setup lang="ts">
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// 应用根组件：Element Plus 全局语言包固定为简体中文（默认语言规则见 ui-design-system.md）。
</script>
